export default "__VITE_ASSET__ByteDwCd__"